import React from 'react';

import { IResourceComponentsProps, useShow } from '@pankod/refine-core';
import {
  Show,
  RefreshButton,
  TextField,
  Row,
  Col,
  TagField,
  ListButton,
  Space,
} from '@pankod/refine-antd';

import { UserTypes } from 'interfaces';

const UserData: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<UserTypes>({
    resource: 'users',
    metaData: {
      fields: ['id', 'name', 'email', 'role', 'createdAt'],
    },
  });
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show
      isLoading={isLoading}
      headerProps={{
        extra: (
          <Space>
            <ListButton />
            <RefreshButton onClick={() => queryResult.refetch()} />
          </Space>
        ),
      }}
    >
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <TextField strong value='ID' />
        </Col>
        <Col span={24}>
          <TagField value={record?.id} />
        </Col>
        <Col span={24}>
          <TextField strong value='Name' />
        </Col>
        <Col span={24}>
          <TagField value={record?.name} />
        </Col>
        <Col span={24}>
          <TextField strong value='Email' />
        </Col>
        <Col span={24}>
          <TagField value={record?.email} />
        </Col>

        <Col span={24}>
          <TextField strong value='Role' />
        </Col>
        <Col span={24}>
          <TagField value={record?.role} />
        </Col>
      </Row>
    </Show>
  );
};

export default UserData;
